<template>
  <div v-if="news" class="news-detail">
    <h1>{{ news.title }}</h1>
    <p class="news-meta">Posted on {{ news.date }} by {{ news.author }}</p>
    <h3>简介：</h3>
    <p v-html="news.description"></p>
    <p v-if="news.details">
      时间: {{ news.details.time }} 地点: {{ news.details.location }}
    </p>
    
    <!-- 显示单张图片 -->
    <div v-if="news.image">
      <h3>相关图片：</h3>
      <img
        :src="news.image"
        alt="新闻图片"
        ref="singleImage"
        :class="imageClass(news.image)"
      />
    </div>

    <!-- 显示多张图片 -->
    <div v-if="news.images && news.images.length">
      <h3>相关图片：</h3>
      <div class="image-gallery">
        <img
          v-for="(img, index) in news.images"
          :key="index"
          :src="img"
          alt="新闻图片"
          ref="image"
          :class="imageClass(img)"
        />
      </div>
    </div>

    <!-- 显示视频 -->
    <div v-if="news.video">
      <h3>相关视频：</h3>
      <video controls>
        <source :src="news.video" type="video/mp4" />
        您的浏览器不支持视频播放。
      </video>
    </div>

    <div class="news-footer">
      <span>Posted in {{ news.categories.join(", ") }}</span>
    </div>
  </div>
  
  <!-- 加载中提示 -->
  <div v-else>
    <p>正在加载新闻...</p>
  </div>
</template>

<script>
export default {
  name: "NewsDetailView",
  data() {
    return {
      news: null, // 当前新闻详情
    };
  },
  mounted() {
    this.loadNewsData();
  },
  methods: {
    async loadNewsData() {
      try {
        const response = await fetch("/newsdetail.json");
        const newsList = await response.json();
        const newsIndex = this.$route.params.id; // 从路由获取新闻 ID
        this.news = newsList[newsIndex] || null; // 获取对应的新闻
      } catch (error) {
        console.error("加载新闻详情失败:", error);
      }
    },
    // 根据图片的宽高判断横向竖向，返回相应的类名
    imageClass(imgSrc) {
      const imgElement = new Image();
      imgElement.src = imgSrc;
      return imgElement.width > imgElement.height ? "landscape" : "portrait";
    },
  },
};
</script>

<style scoped>
.news-detail {
  padding: 1.25rem;
}

.news-meta {
  font-size: 1rem;
  color: #666;
}

.news-footer {
  margin-top: 1.25rem;
  font-size: 0.9rem;
  color: #888;
}

.news-detail img {
  max-width: 100%; /* 保证图片宽度自适应 */
  height: auto; /* 自动调整高度，保持比例 */
  display: block;
  margin: 0 auto;
  border-radius: 0.5rem;
  box-shadow: 0 0.625rem 1.875rem rgba(0, 0, 0, 0.1);
}

.news-detail video {
  max-width: 100%; /* 保证视频宽度自适应 */
  height: auto; /* 自动调整高度，保持比例 */
  display: block;
  margin: 0 auto;
}

.image-gallery {
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
  justify-content: center;
}

.image-gallery img {
  width: 100%; /* 图片宽度自适应 */
  max-width: 25rem; /* 最大宽度 */
  height: auto;
  min-height: 10rem; /* 保证最小高度 */
  object-fit: cover; /* 保持图片的比例并填充容器 */
  border-radius: 0.5rem;
  box-shadow: 0 0.625rem 1.875rem rgba(0, 0, 0, 0.1);
}

.image-gallery img.landscape {
  width: 30%; /* 横向图片宽度填充 */
  height:auto;
  
}

.image-gallery img.portrait {
  height: 25rem; /* 竖向图片固定高度 */
  width: auto; /* 宽度自适应 */
}

@media (max-width: 768px) {
  .image-gallery img {
    max-width: 90%;
  }
}

@media (max-width: 480px) {
  .image-gallery img {
    max-width: 100%;
  }
}
</style>
